<template>
    <!-- 代岗申请 -->
    <div>
        <div v-show="Dgsq">
            <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">代岗申请</div>
            <!-- 主体 -->
            <div style="height:750px;background-color:white;margin:75px 40px 0 40px">
                <!-- 查询框 -->
                <div style="margin-left:3%">
                    <div style="height:10px"></div>
                    <div style="display:inline-block">
                        <span>组织架构 </span>
                        <el-cascader v-model="condition.organize_ids" clearable
                            style="margin-left:10px;width:300px" collapse-tags :props="props"></el-cascader>
                    </div>

                    <div style="display:inline-block;margin-left:20px">
                        <span>城市 </span>
                        <el-select v-model="condition.city_id" style="margin-left:10px;width:150px"
                            :placeholder="postPlaceholder" clearable>
                            <el-option v-for="item in $globals.cityList" :key="item.city" :label="item.city"
                                :value="item.city">
                            </el-option>
                        </el-select>
                    </div>

                    <div style="display:inline-block;margin-left:20px">
                        <span>代岗时间 </span>
                        <el-date-picker v-model="condition.date" type="datetimerange" range-separator="至"
                            start-placeholder="开始日期" format="yyyy-MM-dd HH:mm" end-placeholder="结束日期"
                            value-format="yyyy-MM-dd HH:mm">
                        </el-date-picker>
                    </div>

                    <div style="display:inline-block;margin-left:20px">
                        <span>岗位 </span>
                        <el-select v-model="condition.post_id" style="margin-left:10px;width:150px" placeholder="请选择"
                            clearable>
                            <el-option v-for="item in postList" :key="item.id" :label="item.post_name" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>

                    <br />

                    <div style="display:inline-block; margin-top: 20px;">
                        <span>姓名 </span>
                        <el-input v-model="condition.replace_staff_name" style="margin-left:10px;width:150px"
                            placeholder="请输入姓名"></el-input>
                    </div>

                    <div style="display:inline-block;margin-left:20px">
                        <span>状态 </span>
                        <el-select v-model="condition.reviewer_state" style="margin-left:10px;width:150px"
                            placeholder="请选择" clearable>
                            <el-option v-for="item in ztList" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>

                    <!-- 按钮 -->
                    <div style="display:inline-block;margin-left:50px">
                        <el-button type="goon" @click="Find">查询</el-button>
                        <el-button type="goon" @click="Del(null)">删除</el-button>
                        <el-button type="addbtn" @click="add">新增</el-button>
                    </div>
                </div>

                <!-- 表格 -->
                <div style="margin:2% 3% 0 3%">
                    <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
                        :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
                        style="width: 100%;" height="540" @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <el-table-column align="center" label="序号" width="50">
                            <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
                        </el-table-column>
                        <el-table-column prop="organize_name" align="center" label="组织架构" width="300"></el-table-column>
                        <el-table-column prop="city_id" align="center" label="城市"></el-table-column>
                        <el-table-column prop="post_name" align="center" label="职位" width="120"></el-table-column>
                        <el-table-column align="center" label="代岗人" width="100">
                            <template slot-scope="scope">
                                <el-link type="success" :underline="false" @click="dgr(scope.row.replace_staff)">
                                    {{scope.row.replace_staff_name}}
                                </el-link>
                            </template>
                        </el-table-column>
                        <el-table-column prop="replace_reason" align="center" label="代岗原因" width="300"></el-table-column>
                        <el-table-column prop="replace_type" align="center" label="类别" width="300">
                            <!-- <template>
                                <span>

                                </span>
                            </template> -->
                        </el-table-column>
                        <el-table-column prop="start_date" align="center" label="代岗开始时间" width="160">
                        </el-table-column>
                        <el-table-column prop="end_date" align="center" label="代岗结束时间" width="160">
                        </el-table-column>
                        <el-table-column prop="replace_days" align="center" label="天数"></el-table-column>
                        <el-table-column prop="day_price" align="center" label="元/天"></el-table-column>
                        <el-table-column prop="total_amount" align="center" label="总金额"></el-table-column>
                        <!-- <el-table-column align="center" label="状态" width=100>
                            <template slot-scope="scope">
                                <img src="../../../assets/待审批.png" v-show="scope.row.reviewer_state === '0'" />
                                <img src="../../../assets/已同意.png" v-show="scope.row.reviewer_state === '1'" />
                                <img src="../../../assets/stateImg/状态_已驳回.png"
                                    v-show="scope.row.reviewer_state === '2'" />
                            </template>
                        </el-table-column> -->
                        <el-table-column align="center" label="操作" width="150" fixed="right">
                            <template slot-scope="scope">
                                <img src="../../../assets/编辑.png" @click="Edit(scope.row)">
                                <img src="../../../assets/删除.png" @click="Del(scope.row.id)">
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- 分页 -->
                    <el-row style="margin-top: 10px; text-align: center;">
                        <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                            layout=" prev, pager, next, jumper" :total="total">
                        </el-pagination>
                    </el-row>
                </div>

            </div>
        </div>
        <add ref="adds" v-show="showadd" :organizeList="organizeList"></add>
        <!-- 代岗人 -->
        <el-dialog title="代岗人" v-if="dialogVisible" :visible.sync="dialogVisible" width="40%"
            :close-on-click-modal="false" :center="true">
            <dgr ref="daigangrens" v-show="showdai" :replace_staff_List="replace_staff_List"></dgr>
        </el-dialog>
    </div>
</template>

<script>
    import add from './Dgsq_add.vue';
    import dgr from './Dgsq_dgr.vue';
    import axios from 'axios';
    export default {
        components: {
            add: add,
            dgr: dgr,
        },
        data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
            return {
                //列表相关
                page_num: 1,
                page_size: 10,
                total: 0,
                tableData: [],

                //条件
                condition: {
                    id: '',
                    organize_ids: [],
                    city_id: '',
                    date: '',
                    start_date: '',
                    end_date: '',
                    post_id: '',
                    replace_staff_name: '',
                    reviewer_state: '',
                },

                //详情
                ruleForm: {
                    id: '',
                    spare5: '',
                    project_id: '',
                    city_id: '',
                    post_id: '',
					post_name:'',
                    replace_staff: '',
                    replace_staff_name: '',
                    replace_reason: '',
                    replace_type: '',
                    start_date: '',
                    end_date: '',
                    replace_days: '',
                    day_price: '',
                    total_amount: '',
                    examineDetailsList: [],
                },
                // 权限
                Dgsq: true,
                showadd: false,
                showdai: false,

                //页面相关
                dialogVisible: false,

                //删除ids
                ids: [],

                //岗位下拉
                postList: [],
                //状态下拉
                ztList: [{
                    value: '0',
                    label: '待审批'
                }, {
                    value: '1',
                    label: '已同意'
                }, {
                    value: '2',
                    label: '已驳回'
                }],

                //查询代岗人
                replace_staff_List: [],

                //级联下拉配置
                props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
                    value: "id",
                    label: "organize_name",
                    children: "organizeList",
                    checkStrictly: true,
                    multiple: true,
                },

                //组织架构数据
                organizeList: [],
            };
        },
        methods: {
            // 全选
            handleSelectionChange(e) {
                this.ids = [];
                e.forEach(item => {
                    this.ids.push(item.id);
                });
            },
            // 返回
            Return() {
                this.showadd = false;
                this.Dgsq = true;
                this.trash();
                this.Find();
            },
            // 查看代岗人
            async dgr(e) {
                var replace_staff_List = await this.$globals.AxiosPost("staff/selectFind", {
                    idString: e
                });
                this.replace_staff_List = replace_staff_List.data;

                this.dialogVisible = true;
                this.showdai = true;
            },
            // 新增
            add() {
                this.Dgsq = false;
                this.showadd = true;
                this.trash();
            },
            // 操作详情
            Edit(e) {
                this.Dgsq = false;
                this.showadd = true;

                this.ruleForm.id = e.id;

                this.ruleForm.spare5 = [];
                e.spare5.split(",").forEach(item => {
                    if (item != '' && item != null) {
                        this.ruleForm.spare5.push(parseInt(item));
                    }
                })

                this.ruleForm.project_id = e.project_id;
                this.ruleForm.city_id = e.city_id;
                this.ruleForm.post_id = e.post_id;
                this.ruleForm.replace_staff = e.replace_staff;
                this.ruleForm.replace_staff_name = e.replace_staff_name;
                this.ruleForm.replace_reason = e.replace_reason;
                this.ruleForm.start_date = e.start_date;
                this.ruleForm.end_date = e.end_date;
                this.ruleForm.replace_days = e.replace_days;
                this.ruleForm.day_price = e.day_price;
                this.ruleForm.total_amount = e.total_amount;
                this.ruleForm.replace_type = e.replace_type;
            },
            //查询
            async Find() {
                var temporary = [];
                this.condition.organize_ids.forEach(item => {
                    temporary.push(item[item.length - 1]);
                })
                var organize_ids = "";
                temporary.forEach(item => {
                    organize_ids += item + ",";
                })

                var url = 'replacePost/find';
                var record = {
                    page_num: this.page_num,
                    page_size: this.page_size,
                    organize_ids: organize_ids,
                    city_id: this.condition.city_id,
                    start_date: this.condition.date != null && this.condition.date != '' ? this.condition.date[
                        0] : "",
                    end_date: this.condition.date != null && this.condition.date != '' ? this.condition.date[
                        1] : "",
                    post_id: this.condition.post_id,
                    replace_staff_name: this.condition.replace_staff_name,
                    reviewer_state: this.condition.reviewer_state,
                    applicant_id:this.$globals.user.staff_id,
                };
                var data = await this.$globals.AxiosPost(url, record);
                if (data === '-2000') {
                    this.$message.error('服务器未响应！请稍后重试');
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.tableData = data.list;
                        this.total = data.total;
                    } else {
                        this.$message.warning('请求失败！请稍后重试');
                    }
                }
            },
            // 操作删除
            async Del(e) {
                var ids;
                if (e === null || e === "" || e === undefined) {
                    if (this.ids === null || this.ids.length <= 0) {
                        this.$message.warning("请先选择操作数据！");
                        return false;
                    }
                    ids = this.ids;
                } else {
                    ids = [e];
                }

                var url = "replacePost/del";
                var record = {
                    ids: ids,
                };
                var data = await this.$globals.AxiosPost(url, record);
                if (data === "-2000") {
                    this.$message.error("服务器未响应！请稍后重试");
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.$message.success(data);
                        this.trash();
                        this.Find();
                    } else {
                        this.$message.warning(data);
                    }
                }
            },

            //分页
            handleCurrentChange(val) {
                this.page_num = val;
                this.Find();
            },
            //清除数据
            trash() {
                this.ruleForm.id = '';
                this.ruleForm.spare5='';
                this.ruleForm.company_id = '';
                this.ruleForm.plate_id = '';
                this.ruleForm.project_id = '';
                this.ruleForm.city_id = '';
                this.ruleForm.post_id = '';
				this.ruleForm.post_name = '';
                this.ruleForm.replace_staff = '';
                this.ruleForm.replace_staff_name = '';
                this.ruleForm.replace_reason = '';
                this.ruleForm.start_date = '';
                this.ruleForm.end_date = '';
                this.ruleForm.replace_days = '';
                this.ruleForm.day_price = '';
                this.ruleForm.total_amount = '';
                this.ruleForm.examineDetailsList = [];
                this.ruleForm.replace_type = '';
            },
            //初始化组织架构及下面的人
            async organizeFind() {
                var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
                    identification: "1",
                    id: this.condition.project_id
                });
                this.organizeList = this.getTreeData(organizeList.data);

            },
            getTreeData(data) {
                // 循环遍历json数据
                for (var i = 0; i < data.length; i++) {

                    if (data[i].organizeList.length < 1) {
                        // children若为空数组，则将children设为undefined
                        data[i].organizeList = undefined;
                    } else {
                        // children若不为空数组，则继续 递归调用 本方法
                        this.getTreeData(data[i].organizeList);
                    }
                }
                return data;
            }
        },
        async created() {
            this.Find();
            this.organizeFind();
            // 岗位
            var postList = await this.$globals.AxiosPost("post/selectFind", {});
            this.postList = postList.data;
        },
    };
</script>

<style>
    .el-button--goon:focus,
    .el-button--goon:hover {
        background: #006e4b;
        border-color: #05573d;
        color: #fff;
    }

    .el-button--addbtn:focus,
    .el-button--addbtn:hover {
        background: #fff;
        border-color: #05573d;
        color: #006e4b;
    }

    .el-button--goon {
        color: #fff;
        background-color: #006e4b;
        border-color: #006e4b;
        font-size: 15px;
        width: 85px;
    }

    .el-button--addbtn {
        color: #006e4b;
        background-color: #fff;
        border-color: #006e4b;
        font-size: 15px;
        width: 85px;
    }

    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #006e4b;
        border-color: #006e4b;
    }

    .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #006e4b;
    }

    .el-checkbox__inner:hover {
        border-color: #006e4b;
    }
</style>



// WEBPACK FOOTER //
// Dgsq.vue?44542f10